import { FaBriefcase } from 'react-icons/fa';
import { useT } from '../../hooks/useT';
import styles from './Timeline.module.css';

function Timeline({ items = [] }) {
  const t = useT();

  return (
    <div className={styles.timeline}>
      {items.map((item) => (
        <article key={item.id} className={styles.timelineItem}>
          <div className={styles.iconCircle}>
            <FaBriefcase />
          </div>
          <div className={styles.card}>
            <h2 className={styles.role}>{t(item.roleKey)}</h2>
            <p className={styles.company}>{t(item.companyKey)}</p>
            <p className={styles.period}>{item.period}</p>
            <p className={styles.description}>{t(item.descriptionKey)}</p>
          </div>
        </article>
      ))}
    </div>
  );
}

export default Timeline;
